import { render, staticRenderFns } from "./EditCampaign.vue?vue&type=template&id=24733e72&scoped=true&"
import script from "./EditCampaign.vue?vue&type=script&lang=js&"
export * from "./EditCampaign.vue?vue&type=script&lang=js&"
import style0 from "./EditCampaign.vue?vue&type=style&index=0&id=24733e72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24733e72",
  null
  
)

export default component.exports